import type { AxiosResponse } from 'axios';
import axios from 'axios';
import type { Site } from '@hotjar/site';
import { isAllowed } from '@hotjar/feature-flags';
import type { ResponseLimitInfo } from './ResponseLimitInfo';

const buildGetResponseLimitInfoEndpoint = ({ site }: { site: Site }) => {
  const separateAskServicePrefix = isAllowed('ask.separate_service', site) ? 'ask/' : '';
  return `/api/${separateAskServicePrefix}v1/sites/${site.id}/responses_allowance`;
};

const getData = <T>(response: AxiosResponse<T>): T => response.data;

export function getResponseLimitInfo(site?: Site): Promise<ResponseLimitInfo> {
  if (site === undefined) {
    return Promise.reject(new Error('Invalid site'));
  }

  return axios.get(buildGetResponseLimitInfoEndpoint({ site })).then(getData);
}
